import { Badge } from '@/components/ui/badge'
import type { CustomerType } from '../types'

const LABELS: Record<CustomerType, string> = {
  PERSON: 'Osoba',
  COMPANY: 'Firma',
}

export function CustomerTypeBadge({ type }: { type: CustomerType }) {
  return (
    <Badge variant={type === 'COMPANY' ? 'default' : 'secondary'}>
      {LABELS[type]}
    </Badge>
  )
}
